import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Dialog, DialogDescription, DialogOverlay, DialogPortal, DialogTrigger } from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { useMountEffect } from '@react-hookz/web';
import { useCallback, useRef } from 'react';
import { Backdrop, CloseButton, Content, Title } from '../../primitives/ContentLayer/components/index.js';
export const ContentLayer = /*#__PURE__*/_styled(({
  open = false,
  onClose,
  closeButtonLabel,
  children,
  title,
  visuallyHideTitle,
  description,
  small = false,
  triggerElement,
  onOpenChange,
  ...restProps
}) => {
  const portalRoot = useRef(null);
  useMountEffect(() => {
    portalRoot.current = document.getElementById('portal-root');
  });
  const handleOpenChange = useCallback(nextOpenState => {
    onOpenChange?.(nextOpenState);
    if (nextOpenState === false && onClose) {
      onClose();
    }
  }, [onClose, onOpenChange]);
  const shouldRenderDescription = Boolean(description);
  const describedBy = {};
  if (!shouldRenderDescription) {
    describedBy['aria-describedby'] = undefined;
  }
  return _jsxs(Dialog, {
    open: triggerElement ? undefined : open,
    onOpenChange: handleOpenChange,
    modal: true,
    children: [triggerElement && _jsx(DialogTrigger, {
      asChild: true,
      children: triggerElement
    }), _jsx(DialogPortal, {
      container: portalRoot.current,
      children: _jsxs(DialogOverlay, {
        children: [_jsx(Backdrop, {}), _jsxs(Content, {
          ...describedBy,
          small: small,
          ...restProps,
          children: [!!title && _jsx(Title, {
            visuallyHidden: visuallyHideTitle,
            children: visuallyHideTitle ? _jsx(VisuallyHidden, {
              children: title
            }) : title
          }), _jsx(VisuallyHidden, {
            asChild: true,
            children: _jsx(DialogDescription, {
              children: description
            })
          }), _jsx(CloseButton, {
            label: closeButtonLabel,
            small: small
          }), children]
        })]
      })
    })]
  });
}, process.env.NODE_ENV === "production" ? {
  target: "e19ikhln0"
} : {
  target: "e19ikhln0",
  label: "ContentLayer"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");